import AsyncPrepleafEditor from 'prepleaf-editor';
import { useEffect, useState } from 'react';
interface EditorProps {
	content: string;
	readOnly?: boolean;
	setContent?: (questionText: string) => void;
}
const StudentEditor = ({ content, setContent, readOnly }: EditorProps) => {
	const [key, setKey] = useState(0);
	useEffect(() => {
		if (readOnly) {
			setKey(key);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [content, readOnly]);
	return (
		<div>
			<AsyncPrepleafEditor
				key={key}
				readOnly={readOnly}
				onChange={(value: any) => {
					setContent && setContent(JSON.stringify(value?.rawContent));
				}}
				rawContent={content ? content || null : null}
			/>
		</div>
	);
};

export default StudentEditor;
